import type { ComponentProps } from 'react';

import type { TabList } from '@change/ds-core-ui/Tabs';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useNewsAndGuidesDetailsPageData } from '#src/app/pages/newsAndGuides/details/pageContext';

type Result = ModelHookResult<{
	isGuide: boolean;
	tabItems: ComponentProps<typeof TabList>['items'];
	showSapCta: boolean;
}>;

export function usePageHeading(): Result {
	const { translate } = useI18n();
	const {
		data: { hasGuides, details, countryCode },
	} = useNewsAndGuidesDetailsPageData();

	const urlBase = `/l/${encodeURIComponent(countryCode)}`;

	const tabItems = [
		{
			id: 'news',
			label: translate('fe.components.news_header.news'),
			href: urlBase,
		},
		...(hasGuides
			? [
					{
						id: 'guides',
						label: translate('fe.components.footer.guides'),
						href: `${urlBase}?category=guides`,
					},
				]
			: []),
	];

	return {
		data: {
			isGuide: details.__typename === 'Guide',
			tabItems,
			showSapCta: details.__typename === 'Guide',
		},
	};
}
